import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IC_PHONE, IC_TOPBAR_PODIUM, EXTRATWENTY, IC_DOWNLOAD_APP, IC_ANDROID, IC_IOS, IC_HUAWEI } from '@common/Assets/images';
import useScrollHandler from '@common/Context/useScrollHandler';
import { flagsmith } from '@common/Lib/Flagsmith';
import { FLAGSMITH_KEYS, ONE_ASTER_CATEGORY, REGION_SWITCHER_DISALLOWED_URLS } from '@common/Utility/constants';
import { useTranslation } from '@common/i18n';
import { getConfigurationValue } from '@common/Utility/common-utils';
import { TopBarStyled } from './TopbarStyled';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import RegionLanguageSwitcher from '@common/Component/RegionLanguageSwitcher';
import DownloadAppModal from '../DownloadAppModal/DownloadAppModal';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { useRouter } from 'next/router';

const TopBar = (props) => {
  const scrollY = useScrollHandler();
  const t = useTranslation();
  const generateURL = useNavigationURL();
  const router = useRouter();
  const [showDownloadApp, setShowDownloadApp] = React.useState(false);
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);

  const isDisallowedSwitcher = REGION_SWITCHER_DISALLOWED_URLS.some((disallowedPath) => router?.asPath?.split('?')?.[0]?.indexOf(disallowedPath) > -1);

  const openDownloadAppPopup = () => {
    dataLayerSendEvent('app_download_popup_view', {
            screen_name: props?.screenName,
            page_type: props?.pageType,
            location: 'header component',
            myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
          });

    setShowDownloadApp(true)
  }

  return (
    <TopBarStyled className={`${scrollY > 38 ? 'fixed' : ''} ${isDisallowedSwitcher ? 'hide-mobile' : ''}`}>
      <Container ref={props?.topBarContentRef}>
        <Row className='p-0 m-0'>
          <Col lg={7} xs={12} className="p-0">
            {web_feature_flaging?.isKsaUser ? (
              <ul className="leftSection">
                <li className="cursor-pointer" onClick={openDownloadAppPopup}>
                  <div className="ic">
                    <Image src={IC_DOWNLOAD_APP} alt="Download App Icon" />
                  </div>
                  <div className="label">{t('Header.txtDownloadMyAsterApp')}</div>
                </li>
                <li>
                  {web_feature_flaging?.isAndroidStoreLinkEnable &&
                    <Link
                      passHref
                      href={
                        getConfigurationValue(appConfigData, 'androidPatientAppUrl')
                          ? `${getConfigurationValue(appConfigData, 'androidPatientAppUrl')}`
                          : generateURL('/')
                      }
                    >
                      <a target="_blank" className='app-link'>
                        <Image src={IC_ANDROID} width={60} height={20} alt="" />
                      </a>
                    </Link>
                  }
                  {web_feature_flaging?.isIOSStoreLinkEnable &&
                    <Link
                      passHref
                      href={
                        getConfigurationValue(appConfigData, 'iosPatientAppUrl')
                          ? `${getConfigurationValue(appConfigData, 'iosPatientAppUrl')}`
                          : generateURL('/')
                      }
                    >
                      <a target="_blank" className='app-link'>
                        <Image src={IC_IOS} width={60} height={20} alt="" />
                      </a>
                    </Link>
                  }
                  {web_feature_flaging?.isHuaweiStoreLinkEnable &&
                    <Link
                      passHref
                      href={
                        getConfigurationValue(appConfigData, 'huaweiPatientAppUrl')
                          ? `${getConfigurationValue(appConfigData, 'huaweiPatientAppUrl')}`
                          : generateURL('/')
                      }
                    >
                      <a target="_blank" className='app-link'>
                        <Image src={IC_HUAWEI} width={60} height={20} alt="" />
                      </a>
                    </Link>
                  }
                </li>
              </ul>
            ) : (
              <ul className="leftSection">
                <li>
                  <div className="ic">
                    <Image src={IC_TOPBAR_PODIUM} alt="Healthcare Icon" />
                  </div>
                  <div className="label">{t('Header.txtNumberOnePlatform')}</div>
                </li>
                <li>
                  <div className="ic">
                    <Image src={EXTRATWENTY} alt="Extra Twenty Icon" />
                  </div>
                  <div className="label">{t('Header.txtGetTwentyPercentOff')}</div>
                </li>
              </ul>
            )}
          </Col>
          <Col lg={5} xs={12} className="p-0">
            {/* <Link passHref={true} href={`tel:${appConfig?.data?.find((x) => x.name === 'support_number')?.value}`}> */}
            <ul className="rightSection">
              {!isDisallowedSwitcher &&
                <li>
                  <RegionLanguageSwitcher screenName={props?.screenName} pageType={props?.pageType} />
                </li>
              }
              <li className="no-content">
                {web_feature_flaging?.isHelpLineNumberEnable &&
                  <Link passHref={true} href={`tel:${web_feature_flaging?.helplineNumber?.replace(/-/g, '')}`}>
                    <a className="phone">
                      <div className="ic">
                        <Image src={IC_PHONE} alt="Phone Icon" />
                      </div>
                      <div className="text">{web_feature_flaging?.helplineNumber}</div>
                    </a>
                  </Link>
                }
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
      {showDownloadApp &&
        <DownloadAppModal 
          setShowDownloadApp={setShowDownloadApp} 
          location={'header component'} 
          screenName={props?.screenName} 
          pageType={props?.pageType}
        />
      }
    </TopBarStyled>
  );
};

TopBar.propTypes = {
  topBarContentRef: PropTypes.any,
};

export default TopBar;
